export enum PasswordMaxDateValidationStatus {
  VALID = 'VALID',
  EXPIRED = 'EXPIRED',
  EXPIRES_SOON = 'EXPIRES_SOON'
}
